
<template>
  <div id="app" class="relative overflow-x-hidden w-screen h-screen">
    <!-- <div class="bg-neutral-600">
      <div class="relative text-white text-xsm max-w-screen-xl self-auto items-center justify-center mx-auto py-2">
          <span class="font-semibold text-primary">Update terbaru Covid 19:</span> Completely restore maintainable convergence whereas covalent mindshare. Objectively morph frictionless alignments before technically sound networks. Objectively unleash.
      </div>
    </div> -->
    <oca-navbar></oca-navbar>
    <div class="w-full px-5 w-full flex flex-wrap xl:px-40 lg:px-20 flex flex-wrap mt-10 md:mt-10 lg:mt-20">
      <div id="registerId" class="w-full flex flex-wrap">
        <transition>
        <div class="w-full my-0 flex flex-wrap flex-row items-center">
          <div class="flex flex-col md:px-20 md:w-full lg:w-1/2 lg:px-0">
            <div class="wrapper-left">
                <img class="w-4/5" src="../../assets/image/error_page.png" alt="">
            </div>
          </div>
          <div class="w-full lg:w-1/2 md:w-9/12 md:my-0 md:ml-auto lg:block">
            <div class="wrapper-right">
                  <div class="text-main-color headline-error ">EROR 404: Halaman Tidak Ditemukan</div>
                  <h1>Ups! 404</h1>
                  <p>Halamannya tidak ditemukan. <br>Ayo kita kembali...</p>
                  <a href="https://ocaindonesia.co.id/">Pergi ke Home</a>
              </div>
          </div>
        </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  import OcaNavbar from '../../components/oca_origin/navbar';

  export default {
    name: '500',
    components: {
      OcaNavbar
    },
    data: function () {
     
    },
    mounted() {
    },
    computed:{
   
    },
    created() {

    },
    methods: {
    },
  }
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

    #app {
        font-family: Inter;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

/* $neutral600: #091E42;
$neutral200: #6B778C;
$neutral100: #7A869A;
$neutral300: #5E6C84;
$neutral400: #42526E;
$neutral90: #97A0AF;
$primary: #E81255; */

    .wrapper-left img{
        width: 65%;
        margin: 0 auto;
    }
    .wrapper-right{
        padding-left: 3rem;
    }
    .wrapper-right h1{
        color:  #E81255;
        font-weight: 700;
        font-size: 52px;
        margin-bottom: 3rem;
    }
    .wrapper-right p{
        color:  #5E6C84;
        font-weight: 600;
        font-size: 24px;
        letter-spacing: 1px;
        margin-bottom: 7rem;
    }
   .headline-error{
        font-weight: 400;
        font-size: 16px;
        color:  #E81255;
        margin-bottom: 0px;
    }
    .wrapper-right a{
        text-decoration: none;
        background-color:  #E81255;
        padding: 10px 20px;
        color: #fff;
        border-radius: 5px;
    }

@media screen and (max-width: 1199px) { 
  .wrapper-right p{
      margin-bottom: 5rem;
    }

    .wrapper-right{
      margin: 3rem 0px;
    }
}
@media screen and (max-width: 768px) { 
    .wrapper-left{
        text-align: center;
    }
    .wrapper-left img{
        width: 80%;
    }
    .wrapper-right{
        padding-left: 0px;
        text-align: center;
        margin: 3rem 0px;    
    }
    .wrapper-right h1{
        margin-bottom: 1.5rem;
    }
    .headline-error{
      margin-bottom: 1.2rem;
    }
    .wrapper-right p{
        width: 100%;
        font-size: 18px;
        margin-bottom: 3rem;
    }
}
</style>
